import React, { ComponentProps, Fragment } from 'react';
import _ from 'lodash';
import { FormattedDate } from 'react-intl';
import Thumbnail from 'app/components/Viewer/components/LeftPanel/Thumbnail';
import { ViewerStudy } from 'app/components/Viewer/types';
import isWorkListImage from 'app/utils/isWorkListImage';
import isAnyImagePresentInImages from 'app/components/Viewer/utils/isAnyImagePresentInImages';

type Props = Omit<ComponentProps<typeof Thumbnail>, 'image' | 'specie'> & {
  studies: Record<string, ViewerStudy>;
};

export default React.memo(function ThumbnailsList({ studies, ...thumbnailProps }: Props) {
  const isMultiStudy = _.size(studies) > 1;
  const isAnyImagePresent = _.some(studies, (study) => isAnyImagePresentInImages(study.images));

  return (
    <div className="thumbnails-panel" data-testid="thumbnails-panel">
      {isAnyImagePresent &&
        _.map(_.orderBy(studies, 'creationDate', 'desc'), (study: any) => {
          if (isMultiStudy) {
            return (
              <div key={study._id} className="thumbnails-container">
                <div className="thumbnail-title">
                  <FormattedDate value={study.creationDate} />
                </div>
                {_.map(_.reject(study.images, isWorkListImage), (image) => (
                  <Thumbnail
                    key={image._id}
                    image={image}
                    specie={study.patient?.specie}
                    {...thumbnailProps}
                  />
                ))}
              </div>
            );
          }
          return (
            <div key={study._id} className="thumbnails-container">
              <Fragment>
                {_.map(study.images, (image) => (
                  <Thumbnail
                    key={image._id}
                    image={image}
                    specie={study.patient?.specie}
                    {...thumbnailProps}
                  />
                ))}
              </Fragment>
            </div>
          );
        })}
    </div>
  );
});
